import * as React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { serviceLocator } from '../../services';
import { MainPadding } from '../../components/MainPadding';
import { AppSection } from '../../components/AppSection';
import { withSnackbar, WithSnackbarProps } from '../../components/withSnackbar';
import { Routes, Route } from 'react-router-dom';

import { Footer } from './Footer';
import { AgencyMembers } from './Members';
import { AgencyGeneral } from './General';

const uiService = serviceLocator.getUIService();
const authenticationService = serviceLocator.getAuthenticationService();

const RoleInfo = styled('p')({
  padding: '7px 24px 0px',
  marginBottom: '-10px',
  color: '#8BC34A',
  fontSize: '16px',
});

export interface AgencyPanelState {
  block: "AgencyPanel" | "header";
  html: string;
  style: string;
  script: string;
}
interface AgencyPanelProps extends WithSnackbarProps {
}

export class AgencyPanelInner extends React.Component<AgencyPanelProps, AgencyPanelState>{

  constructor(props: AgencyPanelProps) {
    super(props);
    this.state = {
      block: "AgencyPanel",
      html: "",
      style: "",
      script: ""
    };
  }

  public render() {
    const authUserData = authenticationService.getAuthenticatedUserData();
    const selectedAgency = uiService.getSelectedAgency() || 'all';
    const isAdmin = authUserData?.roles.indexOf('admin') !== -1;
    const hasAgency = authUserData?.ownedAgency == selectedAgency;

    const selectedAgencyData = authUserData ? (authUserData.containedAgencies ? authUserData.containedAgencies.find(item => item.identifier == selectedAgency) : false) : false
    const role = selectedAgencyData ? selectedAgencyData.users[0].AgencyUser.role : "no-role"

    return (
      <div>
        <AppSection section="themePanel" />
        {hasAgency && <RoleInfo>You're the <b>owner</b> of the selected agency: <b>{selectedAgency}</b></RoleInfo>}
        {role == 'agent' && <RoleInfo>You have <b>agent</b> role for the selected agency: <b>{selectedAgency}</b></RoleInfo>}

        {
          selectedAgency == "all" ?
            <MainPadding>
              <Typography color="error">
                Please select an agency on top to work on Agency Panel.
              </Typography>
            </MainPadding>
            :
            <Routes>
              {!(isAdmin || hasAgency || role == 'agent') && <Route path="*" element={<NotAllowed role={role} />} />}
              <Route path="footer" element={<Footer selectedAgency={selectedAgency} />} />
              <Route path="members" element={<AgencyMembers selectedAgency={selectedAgency} />} />
              <Route path="general" element={<AgencyGeneral selectedAgency={selectedAgency} />} />
            </Routes>
        }

      </div>
    );
  }
}

export const AgencyPanel = withSnackbar(AgencyPanelInner);

interface NotAllowedProps {
  role: string;
}

class NotAllowed extends React.Component<NotAllowedProps, any>{

  constructor(props: NotAllowedProps) {
    super(props);
  }

  public render() {
    return (<MainPadding>
      <Typography color="error">
        Resource not allowed. <br />
        You must be an admin or agent for the selected Agency. <br />
        Please try to change the agency on top.</Typography>
    </MainPadding>)
  }

}
